import { Producto_Comercial } from "../constants/constants";

export const validateThereUrl = (url) =>  {
    if(isThereUrl(url)) {
        return url;
    } else {
      return require("../img/no-vacunacion.svg");
    }
} 
export const isThereUrl = (url) =>  url && url !== "";

export const  getVelidateIsMascota = (productoComercial) => {
  let isMascota =  false;
  
  switch(productoComercial) {
    case Producto_Comercial.mascota1:
    case Producto_Comercial.mascota2:
      isMascota = true;
        break;
   }
   return isMascota
}


// WEBPACK FOOTER //
// ./src/mascotas/util-functions.js